import React, { Component } from "react";
import { Route, Redirect, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import Home from "./pages/home";
import Settings from "./pages/settings";

import Accounts from "./pages/accounts";
import AccountForm from "./pages/accounts/accountForm";

import Tickets from "./pages/tickets";
import TicketForm from "./pages/tickets/ticketForm";

import Payments from "./pages/payments";
import PaymentForm from "./pages/payments/paymentForm";

import Invoices from "./pages/invoices";

import Bonuses from "./pages/bonuses";

import NotFound from "./components/notFound";
import HelpDrawer from "./components/help/HelpDrawer";
import NavBar from "./layout/navBar";
import SideNav from "./layout/sideNav";
import Footer from "./layout/footer";

import LoginForm from "./pages/auth/login";
import ForgotPasswordForm from "./pages/auth/forgotPassword";
import ResetPasswordForm from "./pages/auth/resetPassword";
import Logout from "./pages/auth/logout";
import ProtectedRoute from "./components/common/protectedRoute";
import auth from "./services/authService";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";

class App extends Component {
  state = {
    showSideBar: true,
    isHelpOpen: false,
  };

  componentDidMount() {
    const user = auth.getCurrentUser();
    this.setState({ user });
  }

  handleNavButtonClick () {
    let showSideBar = this.state.showSideBar;
    showSideBar = !showSideBar;
    this.setState({showSideBar});
  }

  openHelp = () => {
    this.setState({ isHelpOpen: true });
  };

  closeHelp = () => {
    this.setState({ isHelpOpen: false });
  };

  render() {
    const { user } = this.state;

    return (
      <React.Fragment>
        {/* <ToastContainer /> */}
        <ToastContainer 
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        { user && <NavBar user={user} onHelpOpen={this.openHelp} /> }
        <main className="container">
          <div className="row m-0 flex py-2">
            {/* { user && 
              <span
                className="d-none d-md-block m-0"
                onClick={() => {this.handleNavButtonClick()}}
                style={{ cursor: "pointer" }}
              >
                { !this.state.showSideBar && <i className="fa fa-bars fa-xs text-secondary" /> }
                { this.state.showSideBar && <i className="fa fa-close fa-xs text-secondary" /> }
              </span>
            } */}
            {user && this.state.showSideBar &&
              <div className="col-lg-3 d-none d-md-block">
                <SideNav user={user} />
              </div>
            }
            <div className="col">
              <Switch>
                {/* {!user && <Redirect to="/login" />} */}

                <Route exact path="/login" component={LoginForm} />
                <Route exact path="/forgot-password" component={ForgotPasswordForm} />
                <Route exact path="/reset-password" component={ResetPasswordForm} />
                <Route exact path="/logout" component={Logout} />

                <ProtectedRoute 
                  exact path="/home" 
                  render={props => <Home {...props} user={user} />}
                />
                <ProtectedRoute 
                  path="/settings" 
                  render={props => <Settings {...props} user={user} />}
                />

                <ProtectedRoute
                  path="/accounts/:id"
                  render={props => <AccountForm {...props} user={user} />}
                />
                <ProtectedRoute
                  path="/accounts"
                  render={props => <Accounts {...props} user={user} />}
                />

                <ProtectedRoute
                  path="/tickets/:id"
                  render={props => <TicketForm {...props} user={user} />}
                />
                <ProtectedRoute
                  path="/tickets"
                  render={props => <Tickets {...props} user={user} />}
                />

                <ProtectedRoute
                  path="/payments/:id"
                  render={props => <PaymentForm {...props} user={user} />}
                />
                <ProtectedRoute
                  path="/payments"
                  render={props => <Payments {...props} user={user} />}
                />

                <ProtectedRoute
                  path="/invoices"
                  render={props => <Invoices {...props} user={user} />}
                />

                <ProtectedRoute
                  path="/bonuses"
                  render={props => <Bonuses {...props} user={user} />}
                />

                <Route path="/not-found" component={NotFound} />
                <Redirect to="./home" />
              </Switch>
            </div>
          </div>
        </main>
        { user && (
          <HelpDrawer
            appBase="/client"
            getAuthToken={auth.getAccessToken}
            isOpen={this.state.isHelpOpen}
            onClose={this.closeHelp}
          />
        )}
        { user && <Footer /> }
      </React.Fragment>
    );
  }
}

export default App;
